import React, { useEffect, useState } from "react";
import { Card, ListGroup, ListGroupItem, Modal } from "react-bootstrap";
import { Avatar, Input, Pagination, Table, Toggle } from "rsuite";
import { EmployeeTeamVM } from "../../Models/ViewModels";
import * as CardDetails from "../../Services/EmployeeDB";
import { PageHeader } from "../../SharedComponents/PageHeader";
import { TeamDetails } from "./EmployeeTeamInfo";
import * as helpers from "../../Helpers/Utils"
import { GetUserLoginID, GetUserRole } from "../../Services/UserSessionManager";
const { Column, HeaderCell, Cell } = Table;
export const EmployeeTeamDetailCard=()=>{
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false) ;setTeamDetais([])};
  const [CardInfo,setCardInfo]=useState([]);
  const[teamDetails,setTeamDetais]=useState([]);
  const[filteredInfo,setFilteredInfo]=useState([]);
  const[checkRole,setCheckRole]=useState(GetUserRole());
  const [toggled, setToggled] = useState(false);

  const[loginid,setLoginid]=useState(GetUserLoginID())
  useEffect(()=>{
    CardDetails.GetEmployeeCardStats(loginid).then((res)=>{
     
      setCardInfo(res.data);
      if(checkRole=='M')
      setFilteredInfo(res.data);
      
    })
   
  },[])
const filterData = (val:string,e: any) => {
  let searchText = val;
  if (searchText)
  setFilteredInfo(CardInfo.filter(e => JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())))
  else{
    if(checkRole=='M')
    setFilteredInfo(CardInfo);
    else
    setFilteredInfo([]);
  }
   
}

const showModal=(teamInfo:any)=>{
  setTeamDetais(teamInfo);
  setShow(true);
   
}

    return(
      
      <div className="row">
    
  <Input className="form-control w-25" placeholder="Search EmployeeName or EmployeeId.." type={'search'} onChange={filterData} />

   
      
     {teamDetails.length>0 && <Modal show={show} onHide={handleClose} size="lg"
     dialogClassName="modal-90w"
     aria-labelledby="example-custom-modal-styling-title">
        <Modal.Header closeButton>
            <Modal.Title>
              Team Details
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <TeamDetails teams={teamDetails}/>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
    </Modal>} 
      
      <div>
       <div className="d-flex flex-row flex-wrap justify-content-start align-items-center gap-4 my-3">
        
        {filteredInfo && filteredInfo.map((data:any)=>{
         return(
       <div className="d-flex flex-wrap">
          <div className="card" style={{width: "auto"}}>
              <div className="d-flex justify-content-center m-0 p-2">
                  <Avatar circle size='lg' 
                  {...helpers.stringAvatar(data.EmployeeName)}>
                    </Avatar>
              </div>
              <div className="card-body p-2">
                <div className="d-flex flex-column text-center">
                    <h5 className="card-title m-0"><b>{data.EmployeeName}</b></h5>
                    <div>{data.Designation}</div>
                  </div> 
                <div className="d-flex flex-column justify-content-center pt-3 ">
                  <table>
                    <tbody>
                      <tr>
    
                      </tr>
                    </tbody>
                  </table>
                    <div className="card-subtitle mb-2 text-muted justify-content-center d-flex flex-row ">
                      {/* <div> */}
                      <div className="d-flex flex-column text-start">
                      <b>ID:</b>
                      <b>Department:</b>
                      <b>Location:</b>
                      </div>
                      <div className="d-flex flex-column text-start">
                      <div className="ps-2">
                      <div>{data.EmployeeID}</div>
                      <div>{data.Department}</div>
                      <div>{data.Location}</div>
                      </div>
                      </div>
                          
                    </div>
                 
                  <hr className="m-0"/>
                 
                    <div className="card-text justify-content-center d-flex flex-row pt-2">
                      <div className="d-flex flex-column text-start">
                      <b>Shift: </b>
                      <b>Shift-Timing: </b>
                      <b>Allocation %: </b>
                      <b>Buffer %:</b>
                      <b>Reporting To: </b>
                      <b>Reporting2 : </b>
                      </div>
                      <div  className="d-flex flex-column flex-wrap text-start">
                        <div className="ps-2">
                      <div>{data.Shift}</div>
                      <div>{data.ShiftTiming}</div>
                      <div><small className="text-primary link-simple" onClick={()=>{showModal(data.TeamInfo)}}>{data.TotalAll}</small></div>
                      <div><small className="text-primary link-simple" onClick={()=>{showModal(data.TeamInfo)}}>{data.TotalBuff}</small></div>
                      <div>{data.ReportingOfficerID1}</div>
                      <div>{data.ReportingOfficerID2}</div>
                      </div>
                      </div>
                    </div>
                    </div>
                    </div>
                </div>
              </div>
         )
    })}
    </div>
 
     </div>
  </div>
    )
}